export const checkbox_style = {
  fontFamily: 'Poppins',
  fontSize: '14px',
  fontWeight: '400',
  color: '#737497',
};
